import { HttpResponse } from '@angular/common/http';
import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FileDownloadService} from '@services/file-download.service';
import {FilenameParser} from '@utils/FilenameParser';
import {take} from 'rxjs/operators';
import {BaseFormService} from 'src/app/services/base-form.service';
import {OperadorasService} from 'src/app/services/operadoras.service';
import {CustomSelectOption} from '../../components/select-one/custom-select-option';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { AlertDetalhesBeneficioComponent } from '../../components/alert-detalhes-beneficio/alert-detalhes-beneficio.component';
import { AlertSucessoPadraoComponent } from '../../components/alert-sucesso-padrao/alert-sucesso-padrao.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-operadoras',
    templateUrl: './operadoras.component.html',
    styleUrls: ['./operadoras.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, AlertDetalhesBeneficioComponent, AlertSucessoPadraoComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, SelectOneComponent, MatFormField, MatLabel, MatPrefix, MatInput, MatButton, SelectComponent, NgClass, NgxPaginationModule, FooterComponent, TitleCasePipe, CurrencyPipe]
})
export class OperadorasComponent extends BaseFormService implements OnInit {

  // SELECTS
  public listaEstados: CustomSelectOption[] = new Array();
  public listaSubRegioes: CustomSelectOption[] = new Array();
  public listaOperadoras: CustomSelectOption[] = new Array();

  // TABELA
  public listaBeneficios: any;

  // DETALHE BENEFICIO
  public alertDetalhesBeneficio: any;
  public beneficioSelecionadoAlert: any;
  public qtdPagina: any = 5;
  public pagina: any = 0;
  public totalItems;
  public paginationApi: any;
  public loadingGenerico = false;
  filtrou = false;
  filtroBeneficio: any = '';

  public formFiltro = this.formBuilder.group({

    estado: [null, []],
    subRegiao: [null, []],
    operadora: [null, []]
  });
  public beneficioNaoExistente = false;
  alertSucesso = false;

  constructor(private readonly operadorasService: OperadorasService,
              private readonly formBuilder: UntypedFormBuilder) {
    super();
    this.pagination.pageSize = '5';
  }

  ngOnInit(): void {
    this.buscaGeralDados();
  }

  buscaGeralDados() {
    this.loadingGenerico = true;
    const body: any = {
      estado: null,
      idSubRegiao: null,
      idOperadora: null
    };
    this.operadorasService.getCamposOperadoras(body)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.listaEstados = this.mapearResultados(resposta.response[0].listaEstados, 'estado', 'estado');
          this.listaSubRegioes = this.mapearResultados(resposta?.response[0].listaSubRegioes, 'idSubRegiao', 'descSubRegiao');
          this.listaOperadoras = this.mapearResultados(resposta?.response[0].listaOperadoras, 'idOperadora', 'descBeneficio');
        }
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.loadingGenerico = false;
      }
    });
  }

  buscaDadosPorEstado(estadoSelecionado: any) {
    this.loadingGenerico = true;
    const body: any = {
      estado: estadoSelecionado
    };
    this.operadorasService.getCamposOperadoras(body)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.formFiltro.value.subRegiao = null;
          this.formFiltro.value.operadora = null;
          this.formFiltro.value.estado = estadoSelecionado;
          this.listaSubRegioes = this.mapearResultados(resposta?.response[0].listaSubRegioes, 'idSubRegiao', 'descSubRegiao');
          this.listaOperadoras = this.mapearResultados(resposta?.response[0].listaOperadoras, 'idOperadora', 'descBeneficio');
        }
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.loadingGenerico = false;
      }
    });
  }

  buscaDadosPorSubRegiao(subRegiaoSelecionada: any) {
    this.loadingGenerico = true;
    const body: any = {
      idSubRegiao: subRegiaoSelecionada,
      estado: this.formFiltro.value.estado

    };
    this.operadorasService.getCamposOperadoras(body)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.formFiltro.value.estado = resposta.response[0].listaEstados[0].estado;
          this.listaOperadoras = this.mapearResultados(resposta?.response[0].listaOperadoras, 'idOperadora', 'descBeneficio');
          this.formFiltro.value.operadora = null;
          this.formFiltro.value.subRegiao = subRegiaoSelecionada;
        }
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.loadingGenerico = false;
      }
    });
  }

  buscaDadosPorOperadora(operadoraSelecionada: any) {
    this.loadingGenerico = true;
    const body: any = {
      idOperadora: operadoraSelecionada
    };
    this.operadorasService.getCamposOperadoras(body)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.formFiltro.value.estado = resposta.response[0].listaEstados[0].estado;
          this.formFiltro.value.subRegiao = resposta.response[0].listaSubRegioes[0].idSubRegiao;
          this.formFiltro.value.operadora = operadoraSelecionada;
        }
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.loadingGenerico = false;
      }
    });
  }

  formatarBeneficio(event: Event): void {
    const input = event.target as HTMLInputElement;
    let digits = input.value.replace(/\D/g, '');

    if (digits.length > 5) {
      digits = digits.slice(0, 5);
    }

    let formatted = '';

    if (digits.length <= 2) {
      formatted = digits;
    } else {

      const integerPart = digits.slice(0, digits.length - 2);
      const decimalPart = digits.slice(-2);
      formatted = `${integerPart}.${decimalPart}`;
    }

    this.filtroBeneficio = formatted;
    input.value = formatted;
  }

  // FILTRAR
  filtrar() {
    this.filtrou = true;
    this.beneficioNaoExistente = false;
    this.listaBeneficios = null;
    this.loadingGenerico = true;
    const body: any = {
      estado: this.formFiltro.value.estado,
      idSubRegiao: this.formFiltro.value.subRegiao,
      idOperadora: this.formFiltro.value.operadora,
      codProduto: this.filtroBeneficio
    };
    const paramsArray = this.getParamsFormatArray();
    const paramsUrl = this.getParamsUrl(paramsArray);

    this.operadorasService.getListaOperadoras(paramsUrl, body)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        if (resposta.status === 'OK') {
          this.listaBeneficios = resposta.response.data;
          this.totalItems = resposta.response.pageRequest.total;
          this.paginationApi = resposta.response.pageRequest;
          if (this.pagination.currentPagePaginator > resposta.response.pageRequest.totalPages
            && resposta.response.pageRequest.totalPages !== 0) {
            this.pagination.currentPagePaginator = 1;
            this.pagina = 0;
            this.filtrar();
          }
        }
        this.beneficioNaoExistente = this.listaBeneficios.length === 0;
        this.loadingGenerico = false;
      },
      error: (error: any) => {
        if (error.error.mensagem === 'Nenhum benefício encontrado para o número fornecido') {
          this.beneficioNaoExistente = true;
          this.loadingGenerico = false;
        }
      }
    });
  }

  pageSize(event: any) {
    this.pagination.pageSize = event;
    this.qtdPagina = event;
    this.filtrar();
  }

  getPage(page: number) {
    this.pagination.currentPagePaginator = page;
    this.pagination.currentPageApi = page - 1;
    this.pagina = this.pagination.currentPagePaginator - 1;

    this.filtrar();
  }

  getParamsFormatArray() {

    const arr = [];

    if (this.pagina !== '') {
      arr.push({name: 'pagina', comparator: '=', value: this.pagina});
    }


    if (this.qtdPagina !== '') {
      arr.push({name: 'qtdPorPagina', comparator: '=', value: this.pagination.pageSize});
    }
    return arr;

  }

  // CLICA EM DETALHE DO BENEFICIO
  abrirAlertDetalhesBeneficio(idProduto: any) {
    if (idProduto) {
      this.beneficioSelecionadoAlert = idProduto.toString();
      this.alertDetalhesBeneficio = true;
    }
  }

  // FECHA DETALHE DO BENEFICIO
  eventoAlertDetalhesBeneficio(evento: any) {
    this.alertDetalhesBeneficio = evento;
  }

  // MANUAL OPERADORA
  baixarManualOperadora(idEmpresaOperadora: any) {
    this.operadorasService.getManualOperadora(idEmpresaOperadora)
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.pdf',
        );
        FileDownloadService.download([body], filename);
        this.alertSucesso = true;
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  limparFiltro() {
    this.formFiltro.reset();
    this.listaBeneficios = null;
    this.filtroBeneficio = '';
    this.buscaGeralDados();
    this.beneficioNaoExistente = false;
  }

  campoFiltroPreenchido() {
    return this.filtroBeneficio !== '' ||
      this.formFiltro.value.operadora !== null ||
      this.formFiltro.value.subRegiao !== null ||
      this.formFiltro.value.estado !== null;
  }

  sucessoFechou() {
    this.alertSucesso = false;
  }
}
